<template>
  <button
    class="flex items-center px-4 gap-4 h-12 bg-bgr rounded border border-bgr-300 font-semibold placeholder:text-txt-weak transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-thm-hover focus:border-thm-hover"
    @keydown="handleKeydown"
  >
    <WebccIcon
      v-if="icon"
      :name="icon"
      class="h-5 w-5 shrink-0 pointer-events-none"
    />

    <div class="grow truncate text-left text-base font-semibold">
      <span v-if="text">{{ text }}</span>
      <span v-else class="text-txt-weak">{{ placeholder ?? '' }}</span>
    </div>

    <WebccIcon
      v-if="text"
      name="site/x"
      class="h-5 w-5 shrink-0 cursor-pointer text-txt opacity-20 hover:opacity-60"
      @click.stop="clear"
    />
    <WebccIcon v-else name="site/arrow-down" class="h-4 w-4 shrink-0" />
  </button>
</template>

<script setup lang="ts">
defineProps<{
  icon?: string
  text?: string
  placeholder?: string
}>()

const emit = defineEmits<{ clear: [] }>()

function handleKeydown({ key }: KeyboardEvent) {
  if (['Delete', 'Backspace'].includes(key)) return clear()
}

function clear() {
  emit('clear')
}
</script>
